module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container medi-mass-frame medi-mass-top"
  }, [_vm._m(0), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('section', {
    staticClass: "section-5"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "well"
  }, [(_vm.errorMessage) ? _c('error-display', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "name": "contactMeForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.sendContactRequest.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-9"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('input-text', {
    staticClass: "col-xs-3",
    attrs: {
      "name": "name",
      "label": "First Name",
      "validation": _vm.$v.contactMeCriteria.name
    },
    model: {
      value: (_vm.contactMeCriteria.name),
      callback: function($$v) {
        _vm.$set(_vm.contactMeCriteria, "name", $$v)
      },
      expression: "contactMeCriteria.name"
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "col-xs-3",
    attrs: {
      "name": "lastname",
      "label": "Last Name",
      "validation": _vm.$v.contactMeCriteria.lastName
    },
    model: {
      value: (_vm.contactMeCriteria.lastName),
      callback: function($$v) {
        _vm.$set(_vm.contactMeCriteria, "lastName", $$v)
      },
      expression: "contactMeCriteria.lastName"
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "col-xs-3",
    attrs: {
      "name": "email",
      "label": "Email",
      "validation": _vm.$v.contactMeCriteria.email
    },
    model: {
      value: (_vm.contactMeCriteria.email),
      callback: function($$v) {
        _vm.$set(_vm.contactMeCriteria, "email", $$v)
      },
      expression: "contactMeCriteria.email"
    }
  }), _vm._v(" "), _c('input-text', {
    staticClass: "col-xs-3",
    attrs: {
      "name": "phone",
      "label": "Phone no.",
      "validation": _vm.$v.contactMeCriteria.phoneNumber
    },
    model: {
      value: (_vm.contactMeCriteria.phoneNumber),
      callback: function($$v) {
        _vm.$set(_vm.contactMeCriteria, "phoneNumber", $$v)
      },
      expression: "contactMeCriteria.phoneNumber"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-3"
  }, [_c('button', {
    staticClass: "form-control form-btn btn-danger col-xs-12",
    attrs: {
      "type": "submit",
      "id": "contactMeSubmit",
      "disabled": _vm.loading || _vm.contactRequestSent
    }
  }, [(!_vm.loading) ? _c('span', [_vm._v("\n                    " + _vm._s(_vm.contactMeButtonTitle) + "\n                  ")]) : _c('span', [_c('i', {
    staticClass: "glyphicon glyphicon-refresh glyphicon-refresh-animate"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Loading...")])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _vm._m(9)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://logbox.co.za/#/providers"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("assets/images/medi-mass/medi-mass-header.jpg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("assets/images/medi-mass/screenLeft.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5 text-center line-seperator"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/medi-mass/screen.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("LogBox is an easy to use mobile and web app which allows your patients to capture their personal information once and share it electronically with your practice.")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('h2', [_vm._v("LogBox is integrated with Elixir ")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("\n            You don't have to worry about retyping patient information into your billing system. LogBox is integrated with Elixir so accurate information will flow from LogBox to invoicing in one easy click. It's that simple.")]), _vm._v(" "), _c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("assets/images/medi-mass/elex-logbox.jpg"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-2"
  }, [_vm._m(1)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "bolder"
  }, [_vm._v("Send appointment details ")]), _vm._v("via SMS or Email")]), _vm._v(" "), _c('li', [_vm._v("Patients "), _c('span', {
    staticClass: "bolder"
  }, [_vm._v("connect to your practice")]), _vm._v(" via the "), _c('span', {
    staticClass: "bolder"
  }, [_vm._v("website")]), _vm._v(" or mobile "), _c('span', {
    staticClass: "bolder"
  }, [_vm._v("app")])]), _vm._v(" "), _c('li', [_vm._v("Don't struggle to read bad handwriting, let the "), _c('span', {
    staticClass: "bolder"
  }, [_vm._v("patient fill in their information")]), _vm._v(" for you")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "bolder"
  }, [_vm._v("Practice-specific Terms and Conditions ")]), _vm._v(" are sent to patients "), _c('span', {
    staticClass: "bolder"
  }, [_vm._v("electronically")])]), _vm._v(" "), _c('li', [_vm._v("Create your own "), _c('span', {
    staticClass: "bolder"
  }, [_vm._v("customised questionnaires")]), _vm._v(" using the LogBox form creator")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "bolder"
  }, [_vm._v("Reduce bad debt")]), _vm._v(" with "), _c('span', {
    staticClass: "bolder"
  }, [_vm._v("accurate")]), _vm._v(" patient information ")]), _vm._v(" "), _c('li', [_vm._v("Receive "), _c('span', {
    staticClass: "bolder"
  }, [_vm._v("live updates")]), _vm._v(" if patient details change")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "bolder"
  }, [_vm._v("POPI compliant")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-3"
  }, [_vm._m(3)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', [_vm._v("Patients are frustrated with filling in the same forms over and over again at different healthcare professionals.")]), _vm._v(" "), _c('h1', [_vm._v("Join the LogBox community and move your practice into the digital age. ")]), _vm._v(" "), _c('h1', [_c('span', {
    staticClass: "bolder"
  }, [_vm._v("From LogBox to Elixir in seconds")]), _vm._v(" - you will never want to transcribe a paper form again!")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-4"
  }, [_vm._m(5)])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', [_c('span', {
    staticClass: "bolder"
  }, [_vm._v("Contact")]), _vm._v(" LogBox")]), _vm._v(" "), _c('h2', [_vm._v("We know you're busy, so let us help you. Put your contact details in the fields below and we'll get back to you with all the information you need.\n\t\t\t\t")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "lead"
  }, [_vm._v("Prefer to contact us? Just send an email on "), _c('a', {
    attrs: {
      "href": "mailto:contact@logbox.co.za"
    }
  }, [_vm._v("contact@logbox.co.za")]), _vm._v(" or call us on "), _c('a', {
    attrs: {
      "href": "tel:+27822627238"
    }
  }, [_vm._v("082 262 7238")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://logbox.co.za/#/providers"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("assets/images/medi-mass/medi-mass-footer.jpg"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-537e0c32"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/brochure/MedEMass.vue
// module id = 659
// module chunks = 5